/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explain a cron schedule`)
};

const es_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explica un horario cron`)
};

const de_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Cron-Zeitplan erklären`)
};

const nl_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verklaar een cron-schema`)
};

const fr_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expliquer un horaire cron`)
};

const it_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiega una pianificazione cron`)
};

const pt_br2_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explique um cronograma cron`)
};

const pt_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicar um agendamento cron`)
};

const ja_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cronスケジュールを説明する`)
};

const zh_cr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解释 cron 计划`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_nav_main_desc", locale)
	if (locale === "en") return en_cr_nav_main_desc(inputs)
	if (locale === "es") return es_cr_nav_main_desc(inputs)
	if (locale === "de") return de_cr_nav_main_desc(inputs)
	if (locale === "nl") return nl_cr_nav_main_desc(inputs)
	if (locale === "fr") return fr_cr_nav_main_desc(inputs)
	if (locale === "it") return it_cr_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cr_nav_main_desc(inputs)
	if (locale === "pt") return pt_cr_nav_main_desc(inputs)
	if (locale === "ja") return ja_cr_nav_main_desc(inputs)
	return zh_cr_nav_main_desc(inputs)
};